import React from 'react';
import MailIcon from '../components/MailIcon';
import PhoneIcon from '../components/PhoneIcon';
import LinkedInIcon from '../components/LinkedInIcon';

const SidduSuhasResumePage = () => {
  return (
    <div className="resume-container">
      <h1>Suhas P</h1>
      <div className="contact-info">
        <span className="contact-item">
          <MailIcon />
          <a href="mailto:siddusuhaas124@gmail.com">siddusuhaas124@gmail.com</a>
        </span>
        <span className="contact-item">
          <PhoneIcon />
          +91-9606887799
        </span>
        <span className="contact-item">
          <LinkedInIcon />
          <a href="https://www.linkedin.com/in/siddu-suhas/">Siddu-Suhas</a>
        </span>
      </div>
      <h2>Professional Summary</h2>
      <div className="section">
        Embedded Engineer with over 2 years of experience in firmware development, Linux systems, and Python automation. Proven track record of improving processes, achieving a 40% reduction in data analysis time and a 50% decrease in system downtime. Experienced in leading technical teams, reverse engineering, and building custom root filesystems. Focused on building efficient, secure, and reliable embedded systems.
      </div>

      <h2>Education</h2>
      <div className="section">
        <div className="item">
          <div className="item-title">
            <span><strong>BMS Institute of Technology and Management</strong></span>
            <span>Bengaluru, India</span>
          </div>
          <div className="item-sub">B.E, Electrical and Electronics Engineering; CGPA: 7.63 — May 2019 – May 2023</div>
        </div>
      </div>

      <h2>Experience</h2>
      <div className="section">

        <div className="item">
          <div className="item-title"><span><strong>Probots Electronics India Pvt Ltd</strong></span><span>Bengaluru, India</span></div>
          <div className="item-sub">Embedded Engineer - II (Team Lead) — Apr 2024 – Present</div>
          <ul>
            <li>Performed <strong>reverse engineering</strong> to identify root access vulnerabilities (TOC/TOU, privilege escalation) and developed robust OTA update scripts.</li>
            <li>Engineered CI/CD pipeline using <strong>GitLab CI</strong> to automate firmware compilation.</li>
            <li>Led team for <strong>Crypto Mining Firmware</strong>. Standardized coding and testing with <strong>GTest/GMock</strong> using AI-driven test coverage.</li>
            <li>Integrated <strong>Gemini CLI</strong> to accelerate debugging and reduce RCA time.</li>
            <li>Built custom root filesystems for <strong>Amlogic & CVT boards</strong>. Delivered ESP32-S3 firmware within a week using ESP-IDF + FreeRTOS.</li>
          </ul>
        </div>

        <div className="item">
          <div className="item-title"><span><strong>Probots Techno Solutions</strong></span><span>Bengaluru, India</span></div>
          <div className="item-sub">Embedded Systems Engineer — June 2023 – Mar 2024</div>
          <ul>
            <li>Developed <strong>STM32 firmware</strong> and performed signal analysis for sensors using I2C/SPI.</li>
            <li>Built multithreaded <strong>PyQt GUI dashboard</strong> optimizing system monitoring.</li>
            <li>Automated environment setup, developed support services, enforced Git standards.</li>
          </ul>
        </div>

        <div className="item">
          <div className="item-title"><span><strong>Probots Techno Solutions</strong></span><span>Bengaluru, India</span></div>
          <div className="item-sub">Embedded Systems Engineer - Intern — Feb 2023 – Mar 2023</div>
          <ul>
            <li>Contributed to first crypto mining firmware project; built Python scripts for hardware-firmware data analysis.</li>
          </ul>
        </div>
      </div>

      <h2>Technical Skills</h2>
      <div className="section">
        <ul>
          <li><strong>Languages & Scripting:</strong> Embedded C, C, C++, Python (PyQt), Bash, SQL</li>
          <li><strong>Firmware & Hardware:</strong> STM32, ESP32-S3, Amlogic, ARM Cortex, ESP-IDF, FreeRTOS, PSU Control</li>
          <li><strong>Protocols & Security:</strong> I2C, SPI, UART, TCP/IP, Signal Analysis, Reverse Engineering, OTA Updates</li>
          <li><strong>DevOps & Tools:</strong> GitLab CI, Git, GTest, GMock, GDB, Valgrind, Gemini CLI, Buildroot</li>
        </ul>
      </div>

    </div>
  );
};

export default SidduSuhasResumePage;
